import type { ContactsTranslations } from "../../types/contacts";

export const contacts: ContactsTranslations = {
  sidebar: "Kontaktid",
  title: "Kontaktid",
  subtitleProject: "Projekti osaliste telefoninumbrid, e-posti aadressid ja märkmed",
  subtitleBuilding: "Hoone kõigi projektide kontaktid",
  search: "Otsi kontakte…",
  add: "Lisa kontakt",
  count: "Kontakte: {count}",
  allProjects: "Kõik projektid",
  filter: {
    label: "Vastutusalad",
    clear: "Tühjenda",
    empty: "Erialasid ei leitud.",
  },
  empty: "Kontakte veel pole.",
  emptySearch: "Otsingule vastavaid kontakte ei leitud.",
  loadFailed: "Kontaktide laadimine ebaõnnestus. Palun proovi uuesti.",
  unavailable: "Kontaktid pole veel saadaval. Palun proovi hiljem uuesti.",
  columns: {
    name: "Nimi",
    company: "Ametikoht ja ettevõte",
    responsibilities: "Vastutusalad",
    phones: "Telefon",
    emails: "E-post",
    notes: "Märkmed",
  },
  badges: {
    external: "Väline",
    noAccess: "Juurdepääs puudub",
    you: "Sina",
  },
  actions: {
    menu: "Kontakti toimingud",
    edit: "Muuda",
    delete: "Kustuta",
    addDetails: "Lisa andmed",
    copy: "Kopeeri",
    copied: "Kopeeritud",
    copyFailed: "Kopeerimine ebaõnnestus. Palun proovi uuesti.",
  },
  enteredBy: "Lisas {name}",
  form: {
    createTitle: "Lisa kontakt",
    editTitle: "Muuda kontakti",
    memberTitle: "Kontaktandmed: {name}",
    project: "Projekt",
    projectPlaceholder: "Vali projekt",
    name: "Nimi",
    memberNameHint: "Nimi tuleb tema Franklini profiilist.",
    accountEmail: "Konto e-post",
    company: "Ettevõte",
    jobTitle: "Ametikoht",
    jobTitlePlaceholder: "nt objektijuht",
    responsibilities: "Vastutusalad",
    responsibilitiesPlaceholder: "Lisa erialad",
    phones: "Telefoninumbrid",
    emails: "E-posti aadressid",
    notes: "Märkmed",
    notesPlaceholder: "Kättesaadavus ja muu oluline",
    addPhone: "Lisa telefoninumber",
    addEmail: "Lisa e-posti aadress",
    labelPlaceholder: "Silt, nt mobiil",
    phonePlaceholder: "+372 5555 1234",
    emailPlaceholder: "nimi@ettevote.ee",
    remove: "Eemalda",
    save: "Salvesta",
    cancel: "Tühista",
  },
  errors: {
    projectRequired: "Vali projekt.",
    required: "Sisesta nimi.",
    tooLong: "See on liiga pikk.",
    phoneFormat: "Telefoninumbris peab olema vähemalt üks number.",
    emailFormat: "Sisesta kehtiv e-posti aadress.",
    labelTooLong: "Silt võib olla kuni 50 tähemärki.",
    tooManyPhones: "Lisa kuni 10 telefoninumbrit.",
    tooManyEmails: "Lisa kuni 10 e-posti aadressi.",
    notEditable: "Sa ei saa seda kontakti muuta.",
    createDenied: "Sa ei saa sellele projektile kontakti lisada.",
    editConflict:
      "Muudatust ei saanud salvestada. Kontakt võib olla muutunud või ligipääsmatu. Värskenda nimekirja ja proovi uuesti.",
    confirmationUnknown:
      "Kontakti muudatust ei saanud kinnitada. Värskenda nimekirja enne uuesti proovimist.",
    alreadyExists: "Keegi on selle inimese andmed juba lisanud. Värskendan nimekirja.",
    saveFailed: "Kontakti salvestamine ebaõnnestus. Palun proovi uuesti.",
    deleteFailed: "Kontakti kustutamine ebaõnnestus. Palun proovi uuesti.",
  },
  deleteDialog: {
    title: "Kas kustutada kontakt?",
    description: "{name} eemaldatakse selle projekti kontaktidest.",
    memberDescription:
      "Selle projekti jaoks sisestatud kontaktandmed ({name}) eemaldatakse: telefoninumbrid, e-posti aadressid ja märkmed. Tema juurdepääsu see ei mõjuta.",
    buildingDescription:
      "Selle hoone jaoks sisestatud kontaktandmed ({name}) eemaldatakse: telefoninumbrid, e-posti aadressid ja märkmed. Tema juurdepääsu see ei mõjuta.",
    confirm: "Kustuta",
  },
  toast: {
    saved: "Kontakt salvestatud",
    deleted: "Kontakt kustutatud",
  },
};
